import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeOverviewListComponent } from './badge-overview-list.component';
import { BadgeListItemModule } from '../badge-list-item/badge-list-item.module';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { InlineSVGModule } from 'ng-inline-svg-2';

@NgModule({
  declarations: [BadgeOverviewListComponent],
  imports: [
    CommonModule,
    BadgeListItemModule,
    FGBSharedModule,
    DirectivesModule,
    InlineSVGModule.forRoot(),
  ],
  exports: [BadgeOverviewListComponent],
})
export class BadgeOverviewListModule {}
